<template>
  <li
    :class="mountClass"
  >
    <template v-if="!isAuthorized">
      <router-link
        :to="{ name: PATH_SIGNIN_LOGIN }"
        data-test="sign_in_main_menu"
      >
        <Button
          icon="icon icon-user"
          new-design
          size="large"
          type="primary"
          plain
        >
          {{ $t("header.login") }}
        </Button>
      </router-link>
    </template>
    <template v-else>
      <DropdownUserMenu />
    </template>
  </li>
</template>

<script>
import { mapGetters } from 'vuex';
import { PATH_SIGNIN_LOGIN } from '~/router';

import DropdownUserMenu from './DropdownUserMenu.vue';

export default {
  components: {
    DropdownUserMenu,
  },
  props: {
    mountClass: String,
  },
  data() {
    return {
      PATH_SIGNIN_LOGIN,
    };
  },
  computed: {
    ...mapGetters('auth', [
      'isAuthorized',
    ]),
  },
};
</script>
